// A parent task orchestrating its subtasks (D87): the Subtasks card, pause and resume, and the
// waits that name another task.
export default {
  title: "Subtasks",
  description: "The plan the parent runs, wave by wave, and where each subtask is.",
  noPlan: "No plan yet: the subtasks start once the parent's execution plan is approved.",
  planVersion: (n: number) => `Plan v${n}`,
  wave: (n: number) => `Wave ${n}`,
  parallel: "in parallel",
  after: (refs: string) => `after ${refs}`,
  basedOn: (branch: string) => `based on ${branch}`,
  defaultBase: "based on the default branch",
  needsYou: "Needs you",
  notInPlan: "Not in the plan",
  progress: (done: number, total: number) => `${done}/${total} done`,
  needsYouCount: (n: number) => `${n} needs you`,
  failedCount: (n: number) => `${n} failed`,
  runningCount: (n: number) => `${n} running`,
  orchestrating: "Orchestrating",
  waitingForParent: (ref: string) => `Waiting for ${ref}`,
  paused: "Paused",
  pause: "Pause",
  resume: "Resume",
  pauseHelp: "Start no new step until resumed; a running step finishes.",
  pauseConfirm: "Pause this task?",
  pauseParentBody: "Pausing also pauses its subtasks. Running steps finish; nothing new starts until you resume.",
  pausedToast: "Paused",
  resumedToast: "Resumed",
  baseBranch: "Base branch",
};
